import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NotificationService } from '../../shared/service/notification.service';
import { ValidationError } from '../grease-attributes-import.model';
import { FormHelper } from '../../shared/mixin/form-helper';
import { finalize } from 'rxjs/operators';
import { GreaseAttributesImportService } from "../grease-attributes-import.service";

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss']
})
export class UploadFormComponent extends FormHelper() {
  private static readonly fileAttrDefault = 'Select file';

  public form!: UntypedFormGroup;
  public fileAttr = UploadFormComponent.fileAttrDefault;
  public fileSelected!: File | null;

  public isLoading: boolean = true;
  public isSaving: boolean = false;
  public validationError!: ValidationError | null;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private greaseAttributesImportService: GreaseAttributesImportService,
    private notificationService: NotificationService
  ) {
    super();
    this.validationError = null;
  }
  public onSubmit() {
    if (!this.fileSelected) {
      this.notificationService.error_ts('grease_attributes_import.no_file_selected');

      return;
    }

    this.isSaving = true;
    this.greaseAttributesImportService
      .uploadFile(this.fileSelected)
      .pipe(
        finalize(() => this.isSaving = false)
      )
      .subscribe({
        next: () => {
          this.notificationService.success_ts('grease_attributes_import.upload_success');
          this.onReset();
        },
        error: (response) => {
          this.validationError = {
            message: response.error?.detail,
            columns: response.error?.params['columns']
          }
        }
      });
  }

  public onSelectFile(event: Event): void {
    const files = (event.target as HTMLInputElement).files;

    if (!files) {
      return;
    }

    this.fileAttr = files[0].name;
    this.fileSelected = files[0];
  }

  public onReset(): void {
    this.fileInput.nativeElement.value = '';
    this.fileSelected = null;
    this.fileAttr = UploadFormComponent.fileAttrDefault
    this.validationError = null;
  }
}
